import { Storage } from '@ionic/storage';

export const store = new Storage();

export const initializeStorage = async () => {
  await store.create();
};
